import { useLocation } from "react-router-dom";
import { useBusiness, switchBusiness, MASTER_ID } from "../lib/business";

// Header control on Outreach pages: Master (shared library) or one company.
export default function BusinessSwitcher() {
  const { businesses, id } = useBusiness();
  const loc = useLocation();
  if (!businesses.length) return <div className="text-sm text-slate-400">Outreach</div>;

  const options = [{ id: MASTER_ID, name: "Master" }, ...businesses];
  // Master and companies have different pages; land on a page that exists in the target.
  const target = (to: number) =>
    to === MASTER_ID
      ? (/\/outreach\/(research|roles|campaigns|senders|import)/.test(loc.pathname) ? undefined : "/outreach/research")
      : (/\/outreach\/(contacts|review|logs|verify-log)/.test(loc.pathname) ? undefined : "/outreach");

  return (
    <div className="flex items-center gap-2">
      <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">Working in</span>
      <div className="flex items-center rounded-lg bg-slate-100 p-0.5">
        {options.map((b, i) => (
          <span key={b.id} className="flex items-center">
            {i === 1 && <span className="mx-1 h-4 w-px bg-slate-300" aria-hidden="true" />}
            <button
              onClick={() => { if (b.id !== id) switchBusiness(b.id, target(b.id)); }}
              className={`rounded-md px-3 py-1 text-sm font-semibold transition ${
                b.id === id ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"
              }`}
              aria-pressed={b.id === id}
            >
              {b.name}
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}
